import React from 'react';

import styles from './DesktopOrderProducts.module.css'
import {CartProduct} from "../../../../../widgets/ProductCard/types/productCard.interface.ts";
import {cn} from "../../../../../utils/cn.ts";
import { formatToLocaleString } from '../../../../../utils/formatters/formatToLocaleString.ts';

interface Props {
    orderProducts: CartProduct[],
}

export const DesktopOrderProducts: React.FC<Props> = ({orderProducts}) => {
    return (<>
            <div className={styles.wrapper}>
                <ul className={styles.productList}>
                    {orderProducts.map(({
                                       id,
                                       name,
                                       brand,
                                       article,
                                       price,
                                       amount,
                                   }, idx) => (
                        <li key={id}
                            className={cn(styles.product)}
                        >
                            <div className={styles.info}>
                                <div className={styles.name}>
                                    <span className={styles.nameCounter}>{++idx}. </span>
                                    {name}
                                </div>
                                <div className={styles.infoBottom}>
                                    <div className={styles.brand}>{brand}</div>
                                    <div className={styles.productId}>{article}</div>
                                </div>
                            </div>
                            <div className={styles.price}>{formatToLocaleString(String(price))} ₽</div>
                            <div className={styles.price}>{amount} шт.</div>
                            <div className={styles.outline}/>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};